<template>
    <d-card class="h-100">
        <d-card-header :class="{ 'border-bottom success': config }" class="border-bottom">Google Analytics V4</d-card-header>
        <d-card-body>
            <d-col class="d-flex justify-content-center">
                <img class="img-fluid" src="./assets/ga-v4.jpeg" alt="ga-v4">
            </d-col>
        </d-card-body>
        <d-card-footer class="d-flex justify-content-center">
            <router-link v-if="config" :to="{name: 'google-analytics-v4', params: { websiteId: this.$route.params.id }, query: {redirect: this.redirect}}" class="btn btn-secondary">
                <i class="fa fa-pencil"></i> Edit connection
            </router-link>
            <router-link v-else :to="{name: 'connect-google-analytics-v4', params: { websiteId: this.$route.params.id }, query: {redirect: this.redirect}}" class="btn btn-success">
                <i class="fa fa-plus"></i> Connect
            </router-link>
            <router-link v-if="config && config.is_need_to_reconnect" :to="{name: 'reconnect-google-analytics-v4', params: { websiteId: this.$route.params.id }}" class="btn btn-info ml-3">
                <i class="fa fa-refresh"></i> Reconnect
            </router-link>
        </d-card-footer>
    </d-card>
</template>

<script>
    export default {
        name: 'gaV4',

        props: {
            config: null,
            redirect: null,
        },

        data() {
            return {
                isCreated: true,
                isShowUpdateForm: false,
            };
        },

        created() {
            this.isCreated = false // for getting data (vue-router)
        },

        beforeUpdate() {
            if (! this.isCreated) {
                this.isShowUpdateForm = !!this.config // for already storing google integration, show update form
            }
            this.isCreated = true
        }
    };
</script>
